import { render } from "./change-frequency.vue?vue&type=template&id=920d5ca6&lang=pug"
import script from "./change-frequency.vue?vue&type=script&lang=js"
export * from "./change-frequency.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__